import { type UseQueryResult, useQuery } from 'react-query';
import {
  OpenAPI,
  StaticStatusDropdownService,
  type Wealthlane_CapTable_Dtos_Common_IntDropdownDto,
} from '@wealthlane/api-services/wealthlane-captable-service';
import { type OptionType } from '../../types/common';

const MILESTONE_STATUSES_URL = '/api/cap-table/api/app/static-status-dropdown/milestone-statuses';

const useGetMilestoneStatuses = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  options?: { enabled?: boolean }
): UseQueryResult<OptionType[] | undefined, unknown> => {
  return useQuery(
    ['getMilestoneStatuses'],
    async () => {
      const fn = StaticStatusDropdownService.getApiCapTableApiAppStaticStatusDropdownMilestoneStatuses;
      const promise: Promise<Array<Wealthlane_CapTable_Dtos_Common_IntDropdownDto>> =
        typeof fn === 'function'
          ? fn.call(StaticStatusDropdownService)
          : (async () => {
              const base = (OpenAPI as any).BASE ?? '';
              const token = (OpenAPI as any).TOKEN ?? '';
              const headers = (OpenAPI as any).HEADERS ?? {};
              const res = await fetch(`${base}${MILESTONE_STATUSES_URL}`, {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  ...(token ? { Authorization: `Bearer ${token}` } : {}),
                  ...headers,
                },
              });
              if (!res.ok) return [];
              return res.json();
            })();
      const data = await handleRequest(promise);
      return data?.map((item: Wealthlane_CapTable_Dtos_Common_IntDropdownDto) => ({
        label: item.name ?? '',
        value: item.id,
      }));
    },
    { enabled: options?.enabled !== false }
  );
};

export default useGetMilestoneStatuses;
